//Libs
import React from 'react';
import { Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Hooks
import useUser from '../../../hooks/useUser';
import { useStyles } from './TrackStyles';

const Track = ({ trackingLink, className }) => {
  const { isKiteUser } = useUser;
  const { classes, cx } = useStyles({ isKiteUser });
  return (
    <Button
      className={cx(classes.button, className)}
      href={trackingLink || ''}
      target="_blank"
      endIcon={<ChevronRightIcon className={classes.chevron} />}
      data-testid={'tracking-link-button'}>
      Track
    </Button>
  );
};

export default Track;
